export declare type FILETYPE = 'IMAGE' | 'VIDEO' | 'DOCUMENT' | 'AUDIO';
export const imgExtensions = [
    "apng",
    "avif",
    "gif",
    "jpg",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "png",
    "svg",
    "webp",
];
export const videoExtension = [
    'webm', 'mkv', 'flv', 'vob', 'ogv', 'ogg', 'drc', 'avi', 'wmv', '3gp', '3g2', 'amv', 'mp4', 'm4p', 'mp2', 'mpeg'
]

export const audioExtension = [
    'mp3', 'flac', 'm4a','wmc','wav'
]